"use client";

import { useCallback, useSyncExternalStore } from "react";
import {
  readBrowserPreference,
  subscribeBrowserPreferences,
  writeBrowserPreference,
} from "../lib/browser-preference";

export function useBrowserPreference(key: string, defaultValue: boolean) {
  const value = useSyncExternalStore(
    subscribeBrowserPreferences,
    () => {
      const stored = readBrowserPreference(key);
      return stored === null ? defaultValue : stored === "true";
    },
    () => defaultValue,
  );
  const setValue = useCallback(
    (next: boolean) => writeBrowserPreference(key, String(next)),
    [key],
  );
  return [value, setValue] as const;
}
